import React from 'react';
import { Route, IndexRedirect, IndexRoute } from 'react-router';
import { routeEntryPoint } from '../../config/route-entry-point';

// local
import Root from './modules/root/main';
import DashboardMain from './modules/dashboard/main';
import MarketMain from './modules/market/main';

// shared
import StatGeneralMain from '../../modules/statistics/general/main';
import StatAnalyticsMain from '../../modules/statistics/analytics/main';
import StatConversionsMain from '../../modules/statistics/conversions/main';
import BannedConversionsMain from '../../modules/statistics/ban/main';
import GlobalPostback from '../../modules/global-postback/main';
import GlobalPostbackLog from '../../modules/global-postback/log';
import ResendPostback from '../../modules/global-postback/resendPostback';
import StreamsMain from '../../modules/streams/list/main';
import StreamItem from '../../modules/streams/single/main';
import TicketsMain from '../../modules/tickets/list/main';
import TicketItemMain from '../../modules/tickets/item/main';
import UserApi from '../../modules/user-api/main';
import Ranks from '../../modules/ranks/main';
import Profile from '../../modules/profile/main';
import FinancesMain from '../../modules/finances/main';
// import SpacesMain from '../../modules/spaces/main';
import NewsMain from '../../modules/news/main';
import OffersList from '../../modules/offers/list/main';
import OfferSingle from '../../modules/offers/single/main';
import NotFound from '../../modules/not-found/main';
import Affiliates from '../../modules/affiliates/main';
import MasterAccount from '../../modules/master-account/main';
import PostbackInfo from '../../modules/postback-info/main';
import KeitaroIntegration from '../../modules/keitaro-integration/main';
import BmAccounts from '../../modules/bm-accounts/main';
import BmAccountsItem from '../../modules/bm-accounts/item';

export default (
	<Route component={Root} path={routeEntryPoint}>
		<Route path="dashboard" component={DashboardMain}>
			<Route name="week-chart" path="week-chart/" />
			<Route name="day-chart" path="day-chart/" />
			<IndexRedirect to="week-chart/" />
		</Route>

		<Route path="offers">
			<Route path="public/" component={OffersList} />
			<Route path="my/" component={OffersList} />
			<Route path="affiliates/" component={OffersList} />
			<Route path=":id" component={OfferSingle} />
			<IndexRedirect to="public/" />
		</Route>

		<Route path="news(/:newsId)" component={NewsMain} />

		<Route path="market">
			<IndexRoute component={MarketMain} />
		</Route>

		<Route path="finances" component={FinancesMain}>
			<Route name="history" path="history/" />
			<Route name="conversions" path="conversions/" />
			<Route name="payouts" path="payouts/" />
			<Route name="points" path="points/" />
			<IndexRedirect to="payouts/" />
		</Route>

		<Route path="profile" component={Profile} />

		<Route path="user-api" component={UserApi} />
		<Route path="ranks" component={Ranks} />

		<Route path="tickets">
			<Route path="request/:type(/:offerId)" component={TicketsMain} />
			<Route path=":ticketId" component={TicketItemMain} />
			<IndexRoute component={TicketsMain} />
		</Route>

		<Route path="master-account">
			<IndexRoute component={MasterAccount} ></IndexRoute>
		</Route>

		<Route path="postback-info" component={PostbackInfo} />
		<Route path="keitaro-integration" component={KeitaroIntegration} />

		<Route path="bm-accounts">
			<IndexRoute component={BmAccounts} />
			<Route path=":id" component={BmAccountsItem} />
		</Route>

		<Route path="campaigns">
			<Route path="global-postback"  component={GlobalPostback}/>
			<Route path="global-postback/log"  component={GlobalPostbackLog}/>
			<Route path="global-postback/resend"  component={ResendPostback}/>
			<Route path="new"  component={StreamItem}>
				<Route path=":offerId" component={StreamItem}/>
			</Route>
			<Route path=":streamId" component={StreamItem} />
			<IndexRoute component={StreamsMain} />
		</Route>

		<Route path="statistics">
			<Route path="general" component={StatGeneralMain} />
			<Route path="conversions" component={StatConversionsMain} />
			<Route path="analytics" component={StatAnalyticsMain} />
			<Route path="banned" component={BannedConversionsMain} />
			<IndexRedirect to="general" />
		</Route>

		<Route path="affiliates" component={Affiliates} />

		<IndexRedirect to="dashboard/week-chart/" />
		<Route path="*" component={NotFound} />
	</Route>
);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/routes.js